import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BUYERS_ROUTE } from '../shared/constants/routes';
import { BuyersComponent } from './buyers/buyers.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  {
    path: BUYERS_ROUTE,
    component: BuyersComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuyersRoutingModule {}
